const animes = [
    {
        name: 'yuyu-hakusho',
        image: 'https://m.media-amazon.com/images/M/MV5BYTFiMTE2Y2YtMzNkMi00MTNhLTkxMTEtMDA1N2FhYmY1ZjQ3XkEyXkFqcGdeQXVyNjAwNDUxODI@._V1_SX300.jpg',
        title: 'Yu Yu Hakusho',
        content: [
            `Cant really say much about this anime. Probably one of my favorites of all time. 10/10 I recommend it to anyone.`
        ]
    },
];

export default animes;